module.exports = __webpack_public_path__ + "SA.png?b02ee99c24b4845c79375bbb57bdcf1f";